import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from "./Variables.js";

export default function MatchHomePage() {

  const jsonUrl = variables.basename_url + "updates/index/Athlethixnet_HomeEn_Matches.json";
  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();

  const [Match_HomePage, setMatch_HomePage] = React.useState([]);
  const [Match_HomePageWithResult, setMatch_HomePageWithResult] = React.useState([]);
  const [selectedSport, setSelectedSport] = useState("Football");

  const sportsList = ["Football", "Tennis", "Basketball", "Cricket"];

  const filteredMatches = Match_HomePageWithResult
    .filter(da => da.SGT_name === selectedSport)
    .slice(0, 6);

  async function refda() {
    Get_Data_FMostViewed();
  };

async function Get_Data_FMostViewed() {

  setNisLoading(true);

  axios.get(jsonUrl)
    .then(function (response) {

      const data = response.data || [];
      const matches = data.map(item => {

  const dateTime = item.SM_game_date_time || "";
  const [datePart, timePart] = dateTime.split("T");

  return {
    id: item.SM_id,
    SLT_name_en: item.SLT_name_en?.trim() || "",
    SLT_Logo: item.SLT_Logo,
    SGT_name: item.SGT_name || "",
    Day: datePart || "",
    Time1: timePart ? timePart.slice(0, 5) : "",
    Team1: item.Team1,
    Team2: item.Team2,
    ST_logo: item.ST_logo,
    ST_logo1: item.ST_logo1,
    SM_score1: item.SM_score1,
    SM_score2: item.SM_score2,
    IsPenalties: item.IsPenalties,
    PenaltyScore1: item.PenaltyScore1,
    PenaltyScore2: item.PenaltyScore2,
  };
});

setMatch_HomePageWithResult(matches);
      setNisLoading(false);

    })
    .catch(function (error) {
      console.error("Error fetching data:", error);
      setNisLoading(false);
    });
}

  useEffect(() => {
    setNisLoading(true);
    refda();
  }, []);

  return (
    <>
      <div className="upcoming-matches-post mt-35 most-view-box mt-0 border ">
        <div className="container section-title d-flex justify-content-between align-items-center">
          <h3 className="title">Latest Matches</h3>
          <a href={`${selectedSport}Matches`} style={{ marginRight: "8px" }}> SEE ALL</a>
        </div>

        <div className="container d-flex align-items-center mb-3">
          {sportsList.map(sport => (
            <a
              key={sport}
              href={`${sport}Matches`}
              onClick={(e) => {
                e.preventDefault();
                setSelectedSport(sport);
              }}
            >
              <button
                type="button"
                className={`${selectedSport === sport ? "redbackcolor" : "grayBackground"} text-white py-1 px-2 rounded border border-white mr-2`}
                style={{ fontSize: "13px" }}
              >
                {sport}
              </button>
            </a>
          ))}
        </div>

        <div className="upcoming-matches-post-items">
          <div className="container">
            {filteredMatches.map(da => (
              <div key={da.id} className="match-card d-flex align-items-center justify-content-between p-3 border-0 rounded mb-3">

                {/* Team 1 */}
                <div className="team match-team-col d-flex align-items-center justify-content-start flex-shrink-0">
                  <img src={variables.MatchesImg + da.ST_logo} className="team-logo rounded-circle me-2" alt={da.Team1} />
                  <span className="team-name team-name-fixed text-truncate">
                    {da.Team1}
                  </span>
                </div>

                {/* Date or Score */}
                <div className="match-info match-info-col text-center flex-shrink-0">
                  {da.SM_score1 === '' || da.SM_score1 === '-1' || da.SM_score1 === '-' ? (
                    <>
                      <span className="match-time d-block">{da.Time1}</span>
                      <span className="match-date d-block">{da.Day}</span>
                    </>
                  ) : (
                    <>
                      <span className="match-date-time d-block">
                        <span className='fw-600'>{da.Day}</span>
                      </span>
                      <span className="match-score d-block">
                        {da.SM_score1} <span className="score-separator">-</span> {da.SM_score2}
                      </span>
                      {da.IsPenalties && (
                        <span className="match-penalty-score d-block">
                          ({da.PenaltyScore1 === '' || da.PenaltyScore1 === '-1' || da.PenaltyScore1 == null ? '-' : da.PenaltyScore1}
                          {' - '}
                          {da.PenaltyScore2 === '' || da.PenaltyScore2 === '-1' || da.PenaltyScore2 == null ? '-' : da.PenaltyScore2})
                        </span>
                      )}
                    </>
                  )}
                </div>
                {/* Team 2 */}
                <div className="team match-team-col d-flex align-items-center justify-content-end flex-shrink-0">
                  <img src={variables.MatchesImg + da.ST_logo1} className="team-logo rounded-circle ms-2" alt={da.Team2} />

                  <span className="team-name team-name-fixed text-truncate">
                    {da.Team2}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}